import React, { useRef, useState } from "react";
import { icons } from "../../assets/icons";
import { gsap } from "gsap";
import { isMovilResponsive } from "../../helpers/Constnats";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

export const DialogBarCharacterDress = ({ titulo = "", dialog = "", percentage, genere = false, actionChange = () => { }, children }) => {
	const containerGlobal = useRef(null);
	const containerInfo = useRef(null);
	const [animacionActiva, setAnimacionActiva] = useState(false);
	const toggleSwitchRef = useRef(null);
	const toggleHandleRef = useRef(null);

	const tooggleAnimation = () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.navigationInfo)
		const container = containerGlobal.current;
		const info = containerInfo.current;

		if (!containerGlobal.current || !containerInfo.current) return;

		if (!animacionActiva) {
			gsap.to(container, {
				width: "100%",
				borderRadius: "24px",
				duration: 0.5,
				onComplete: () => {
					gsap.to(info, { opacity: 1, duration: 0.5 });
				},
			});
		} else {
			gsap.to(container, { width: isMovilResponsive ? "40px" : "72px", borderRadius: "40px", duration: 0.5 });
			gsap.to(info, { opacity: 0, duration: 0.2 });
		}
		setAnimacionActiva(!animacionActiva);
	};

	const handleToggle = (anotherGenere) => {
		const handle = toggleHandleRef.current;

		gsap.to(handle, {
			x: anotherGenere ? 0 : isMovilResponsive ? 17 : 33,
			duration: 0.3,
		});
	};

	const changeGender = () => {
		handleToggle(!genere);
		actionChange();
	};

	return (
		// h-[120px] md:h-[200px]
		<div className="fixed z-30 w-full h-full bottom-0  gridDreesContainer">
			<div className="gridCharacterDreesDialog ">
				<div className="flex items-end pl-11 md:pl-12">
					<div className="w-[50px] h-[30px] md:w-[72px] md:h-[40px] flex justify-center items-center overflow-hidden" onClick={changeGender}>
						<div ref={toggleSwitchRef} className={`w-full h-full  bg-white rounded-full p-1 cursor-pointer `}>
							<div className="w-full h-full rounded-full gradiantCssToggleSwitchDrees flex items-center">
								<div ref={toggleHandleRef} className="w-6 h-6 md:w-8 md:h-8 bg-white rounded-full">
									<img className="h-full w-full object-contain" src={!genere ? icons.female : icons.male} alt="genere" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="flex px-10 py-3 md:py-7 overflow-hidden">
					{/* datos w-[40px] md:w-[72px] rounded-[40px] y cuado cree rounded-[24px]*/}
					<div ref={containerGlobal} className="h-full  md:w-[72px] w-[40px] bg-[#292929c3] rounded-[40px] overflow-hidden py-3 md:py-4 ">
						<div className="w-full h-full relative">
							{/* boton de adorno de alerta */}
							<div className="absolute z-20 left-1.5 md:left-5 md:top-2">
								<div className="h-7 w-7 md:w-8 md:h-8">
									<img className="h-full w-full object-contain" src={icons.alerta} alt="alerta" />
								</div>
							</div>
							{/* boton animacion */}
							<div className="absolute z-20 bottom-0 right-1.5 md:right-5">
								<div className="h-full w-full">
									<div className="h-7 w-7 md:w-8 md:h-8 cursor-pointer" onClick={tooggleAnimation}>
										<img
											className="h-full w-full object-contain"
											src={animacionActiva ? icons.backArrow : icons.nextArrow}
											alt="alerta"
										/>
									</div>
								</div>
							</div>
							{/* div de informacion */}
							<div ref={containerInfo} className="w-full h-full px-[45px] md:px-[72px] overflow-hidden opacity-0">
								<div className="w-full h-full grid grid-rows-dialogAnimationGrid md:grid-rows-mddialogAnimationGrid">
									<div className="">
										<p className="text-white font-semibold text-[10px] md:text-[14px]">{titulo}</p>
									</div>
									<div className="">
										<p className="text-white font-semibold text-[9px] md:text-[14px]">{dialog}</p>
									</div>
									<div className="flex items-center">
										<div className="relative w-full bg-[#E6E6E6] h-1">
											<div className=" absolute h-full bg-[#FFC427]" style={{ width: percentage }}></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="h-full w-full overflow-hidden">{children}</div>
		</div>
	);
};
